import React from 'react';
import '../styles/ServicesPage.css'
import Breadcrumbs from './Breadcrumbs';

const ChildServiceLayout = ({ title, intro, children, image, cta }) => {
  return (
    <div className='service-page'>
      <Breadcrumbs />
      <h1>{title}</h1>
      <p>{intro}</p>

      <div className='service-content'>
        <div className='service-description'>{children}</div>
        <div className='service-image-wrapper'>
          <img className='service-image' src={image} alt={title} />
        </div>
      </div>

      {cta && (
        <div className='service-cta'>
          <h2>{cta.heading}</h2>
          <p>{cta.text}</p>
          {cta.link && <a href={cta.link.href} className="cta-button">{cta.link.text}</a>}
        </div>
      )}
    </div>
  );
};

export default ChildServiceLayout;